import {MsalGuardConfiguration, MsalInterceptorConfiguration} from '@azure/msal-angular';
import {environment} from '../environments/environment';
import {
    BrowserCacheLocation,
    Configuration,
    InteractionType,
    IPublicClientApplication,
    LogLevel,
    PublicClientApplication,
} from '@azure/msal-browser';

export const isIE =
    window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
    protectedResourceMap.set(environment.baseApiURL, environment.authentication.scopes);
    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap,
    };
}

const msalConfig: Configuration = {
    auth: {
        clientId: environment.authentication.ApplicationId,
        authority: environment.authentication.Authority + environment.authentication.TenantId,
        redirectUri: environment.authentication.redirectUrl,
        postLogoutRedirectUri: environment.authentication.logoutRedirectUrl,
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: isIE,
    },
    system: {
        loggerOptions: {
            loggerCallback(_logLevel: LogLevel, _message: string) {},
            logLevel: LogLevel.Error,
            piiLoggingEnabled: false,
        },
    },
};

// Module-level singleton: keep one PublicClientApplication shared across
// MSAL_INSTANCE / MsalModule providers so initialize() runs exactly once.
let msalInstance: IPublicClientApplication | undefined;

export function MSALInstanceFactory(): IPublicClientApplication {
    if (!msalInstance) {
        msalInstance = new PublicClientApplication(msalConfig);
    }
    return msalInstance;
}

/**
 * APP_INITIALIZER factory. In @azure/msal-browser v3 the PublicClientApplication
 * must be initialized (initialize() awaited) before any other MSAL call —
 * see https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/v2-migration.md
 */
export function initializeMsal(msal: IPublicClientApplication): () => Promise<void> {
    return () => msal.initialize();
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: (_authService) => {
            return {
                scopes: environment.authentication.scopes,
                authority: environment.authentication.Authority + environment.authentication.TenantId,
                redirectUri: environment.authentication.redirectUrl,
                postLogoutRedirectUri: environment.authentication.logoutRedirectUrl,
            };
        },
    };
}
